import React from 'react'
import Logo from "../assets/logo__pm-1.png"
import grayTick from "../assets/gray-tik.png"
import greenTick from "../assets/green-tik.png"

const Stepper = () => {
  return (
    <div className="w-full gap-3 flex items-center justify-center flex-col">
        <img src={Logo} alt="logo" className="w-52" />
        <div className="flex md:flex-row flex-col md:items-center justify-between max-w-5xl border-t-2 border-gray-300 pt-3  gap-x-16">
          <div className="flex items-center gap-2">
            <img src={greenTick} className="w-4 h-4" />
            <p className="text-sm font-medium">
              Step 1: Checkout
            </p>
          </div>
          <div className="flex items-center gap-2">
            <img src={greenTick} className="w-4 h-4" />
            <p className="text-sm font-medium">
              Step 2: Upgrade Opportunities
            </p>
          </div>
          <div className="flex items-center gap-2">
            <img src={grayTick} className="w-4 h-4" />
            <p className="text-sm font-medium text-gray-600">
              Step 3: Order Receipt
            </p>
          </div>
        </div>
      </div>
  )
}

export default Stepper
